import { List } from "./services/List";

const AuthorQuery = {
  records: [`users?offset=$from&fname=ilike.%$search%&limit=10`, true],
  aggregation: [`users?select=count()&fname=ilike.%$search%`, false],
}

export default () => {
  return (
    <List
      mainKey={"fname"}
      query={AuthorQuery}
      path="/authors"
      name="Autorzy"
      plural="autorów"
    />
  );
};
